"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createCoreMiddleware;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _AudioAttachment = _interopRequireDefault(require("../../Attachment/AudioAttachment"));

var _DownloadAttachment = _interopRequireDefault(require("../../Attachment/DownloadAttachment"));

var _ImageAttachment = _interopRequireDefault(require("../../Attachment/ImageAttachment"));

var _TextAttachment = _interopRequireDefault(require("../../Attachment/TextAttachment"));

var _TypingActivity = _interopRequireDefault(require("../../Attachment/TypingActivity"));

var _VideoAttachment = _interopRequireDefault(require("../../Attachment/VideoAttachment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // TODO: [P4] Rename this file or the whole middleware, it looks either too simple or too comprehensive now


function createCoreMiddleware() {
  return function () {
    return function (next) {
      var Attachment = function Attachment(_ref) {
        var _ref$activity = _ref.activity,
            activity = _ref$activity === void 0 ? {} : _ref$activity,
            attachment = _ref.attachment,
            _ref$attachment = _ref.attachment;
        _ref$attachment = _ref$attachment === void 0 ? {} : _ref$attachment;
        var contentType = _ref$attachment.contentType,
            contentUrl = _ref$attachment.contentUrl;
        return activity.type === 'typing' ? _react.default.createElement(_TypingActivity.default, null) : /^audio\//.test(contentType) ? _react.default.createElement(_AudioAttachment.default, {
          activity: activity,
          attachment: attachment
        }) : /^image\//.test(contentType) ? _react.default.createElement(_ImageAttachment.default, {
          activity: activity,
          attachment: attachment
        }) : /^video\//.test(contentType) ? _react.default.createElement(_VideoAttachment.default, {
          activity: activity,
          attachment: attachment
        }) : contentUrl || contentType === 'application/octet-stream' ? _react.default.createElement(_DownloadAttachment.default, {
          activity: activity,
          attachment: attachment
        }) : /^text\//.test(contentType) ? _react.default.createElement(_TextAttachment.default, {
          activity: activity,
          attachment: attachment
        }) : next({
          activity: activity,
          attachment: attachment
        });
      };

      Attachment.propTypes = {
        activity: _propTypes.default.any.isRequired,
        attachment: _propTypes.default.shape({
          contentType: _propTypes.default.string.isRequired,
          contentUrl: _propTypes.default.string.isRequired
        }).isRequired
      };
      return Attachment;
    };
  };
}